export function isRefreshableAuthStatus(
  statusCode: number | undefined
): boolean {
  return statusCode === 401;
}
